module.exports = __webpack_public_path__ + "static/media/Logo_reveillon_Branca.2a210a49.svg";